import { Box } from "@mui/material";
import { styled } from "@mui/material/styles";

export const LoginStyled = styled(Box)(({ theme }) => ({
  height: 'inherit',

  "& .login-page": {
    background: "#E9EDF0",
    height: 'inherit',
    
    "& .content": {
      width: '100%',
      // height: 'calc(100vh)',
      
      height: "-webkit-fill-available",
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',

      "& .content-1": {
        textAlign: 'center',

        "& h3": {
          margin: 0
        },

        "& h1": {
          marginTop: 0
        },

        "& h1 span": {
          color: "red"
        }
      },

      "& .logo": {
        width: '22px',
        height: '22px',
      },

      "& .image-login": {
        width: '100%', 
        height: 100,
        marginTop: 90,
        marginBottom: 20
      },

      "& button": {
        background: '#EE602C',
        width: '80%',
        height: 50,
        marginTop: 40,
        marginBottom: 20
      },

      "& span,a,h1,h3": {
        color: "#3C3C3C"
      }
    },

    // "& .footer": {
    //   display: 'flex',
    //   justifyContent: 'center',
    //   width: '100%',

    //   "& div": {
    //     width: '100%',
    //     height: 50,
    //     padding: "0px 5px",
    //   },

    //   "& button": {
    //     background: '#EE602C',
    //     width: '100%',
    //     height: 50,
    //   }
    // }
  },
  '@media only screen and (max-width: 800px)': {
    "& .login-page": {
      "& .content": {
        "& .image-login": {
          marginTop: 'calc(10vh)'
        }
      }
    }
  }
}));
